<template>
  <div class="card not-word-wrap mb-3">
    <div class="card-body">
      <Loading v-if="loading" />

      <!-- وارد کردن شماره کارت -->
      <div class="row" v-if="!cardLoaded">
        <div class="col-md-4">
          <form @submit.prevent="fetchCard">
            <label>شماره کارت یا کد ملی</label>
            <div class="input-group">
              <input
                type="tel"
                class="form-control text-center"
                v-mask="
                  this.pan.length > 10 ? '####-####-####-####' : undefined
                "
                v-model="pan"
                dir="ltr"
              />
              <button v-if="panValid" class="btn btn-info" type="submit">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- اطلاعات کارت -->
      <div v-if="cardLoaded">
        <button class="btn btn-secondary" @click="resetInfo">
          جستجوی جدید
        </button>
        <hr />
        <table class="table table-bordered table-hover ">
          <thead>
            <tr>
              <th>نام و نام خانوادگی</th>
              <th>کد ملی</th>
              <th>شماره همراه</th>
              <th>شماره کارت</th>
              <th>وضعیت کارت</th>
              <th>شناسه محصول</th>
              <th>نام گروه</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <td>{{ row.firstName }} {{ row.lastName }}</td>
              <td>{{ row.nationalCode }}</td>
              <td>{{ row.mobileNumber }}</td>
              <td>{{ row.pan }}</td>
              <td
                v-bind:class="{
                  active: row.statusId === 2,
                  diactive: row.statusId !== 2,
                }"
              >
                {{ row.status }}
              </td>
              <td>{{ row.productId }}</td>
              <td>{{ row.productName }}</td>
              <td>
                <div class="mt-3">
                  <button
                    class="btn btn-warning me-2 ml-2"
                    @click="openModal('password', row)"
                  >
                    تغییر رمز
                  </button>
                  <button
                    class="btn btn-primary me-2 ml-2"
                    @click="openModal('mobile', row)"
                  >
                    تغییر شماره
                  </button>
                  <button
                    class="btn btn-danger"
                    @click="openModal('block', row)"
                  >
                    مسدود / رفع مسدودی
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- دکمه‌ها -->
      </div>

      <!-- Modal تغییر رمز -->
      <div class="modal" tabindex="-1" id="passwordModal" ref="passwordModal">
        <div class="modal-dialog">
          <div class="modal-content ">
            <div class="modal-header"><h5>تغییر رمز</h5></div>
            <div class="modal-body">
              <div class="col-md-2">
                <div class="form-group">
                  <label>نوع رمز</label>
                  <select v-model="pinType" class="p-1">
                    <option selected disabled value="">انتخاب کنید</option>
                    <option value="1">رمز اول</option>
                    <option value="2">رمز دوم</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-success"
                  :disabled="!pinType"
                  @click="submitPassword"
                >
                  ثبت و دریافت رمز
                </button>
                <button
                  class="btn btn-secondary"
                  @click="closeModal('password')"
                >
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal تغییر شماره -->
      <div class="modal" tabindex="-1" id="mobileModal" ref="mobileModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header"><h5>تغییر شماره همراه</h5></div>
            <div class="modal-body">
              <label>شماره جدید</label>
              <input v-model="newMobile" type="tel" class="form-control" />
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="closeModal('mobile')">
                بستن
              </button>
              <button
                class="btn btn-success"
                @click="submitMobile"
                :disabled="loading || !newMobileValid"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal مسدود / رفع مسدودی -->
      <div class="modal" tabindex="-1" id="blockModal" ref="blockModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header"><h5>مسدودسازی یا رفع مسدودی</h5></div>
            <div class="modal-body">
              <label>نوع درخواست</label>
              <div>
                <input
                  type="radio"
                  value="3"
                  v-model="blockType"
                  :disabled="selectedRow.statusId !== 2"
                />
                مسدود کردن
              </div>
              <div>
                <input
                  type="radio"
                  value="2"
                  v-model="blockType"
                  :disabled="selectedRow.statusId === 2"
                />
                رفع مسدودی
              </div>
              <label class="mt-2">توضیحات</label>
              <input
                v-model="blockDescription"
                type="text"
                class="form-control"
              />
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="closeModal('block')">
                بستن
              </button>
              <button
                class="btn btn-success"
                @click="submitBlock"
                :disabled="loading"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardActions",
  data() {
    return {
      pan: "",
      loading: false,
      rows: [],

      // modals
      pinType: "",
      selectedRow: {},
      newMobile: "",
      blockType: "",
      blockDescription: "",

      modalInstances: {},
    };
  },

  computed: {
    panValid() {
      return (
        (this.pan && this.pan.replace(/-/g, "").length === 16) ||
        (this.pan && this.pan.trim().length === 10)
      );
    },
    newMobileValid() {
      return (
        this.newMobile &&
        this.newMobile.trim().length === 11 &&
        this.newMobile.startsWith("09")
      );
    },
    cardLoaded() {
      return Object.keys(this.rows).length > 0;
    },
  },

  methods: {
    async confirmAction(message) {
      const result = await this.$swal({
        title: "تأیید عملیات",
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله، انجام بده",
        cancelButtonText: "لغو",
      });

      return result.isConfirmed;
    },
    /* --------------------- Fetch Card Data --------------------- */
    fetchCard() {
      this.loading = true;
      const payload = {
        cardNumber: this.pan.replace(/-/g, ""),
      };
      this.$api
        .post("Cards/GetCardOwnerInfo", payload)
        .then(({ data }) => {
          if (data.status) {
            this.rows = data.result.filter((record) => record.pan);
          } else {
            this.$swal({ icon: "error", text: "کارت یافت نشد" });
          }
        })
        .finally(() => (this.loading = false));
    },

    /* --------------------- Modal handlers ---------------------- */
    openModal(name, row) {
      this.selectedRow = row;
      const modal = new bootstrap.Modal(this.$refs[name + "Modal"]);
      this.modalInstances[name] = modal;
      modal.show();
    },
    closeModal(name) {
      if (this.modalInstances[name]) {
        this.selectedRow = {};
        this.modalInstances[name].hide();
      }
    },

    /* --------------------- تغییر رمز ---------------------- */
    async submitPassword() {
      const ok = await this.confirmAction("آیا از تغییر رمز اطمینان دارید؟");
      if (!ok) return;

      const posted = {
        cardNumber: this.selectedRow.pan.replace(/-/g, ""),
        kindPass: this.pinType,
      };

      this.loading = true;

      this.$api
        .post("Cards/ChangePinNew", posted)
        .then(({ data }) => {
          this.$swal({
            icon: data.status ? "success" : "error",
            text: data.status
              ? "رمز با موفقیت تغییر کرد"
              : data.errors[0].message,
          });
          if (data.status) {
            this.pinType = "";
            this.selectedRow = {};
          }
        })
        .finally(() => {
          this.loading = false;
          this.closeModal("password");
        });
    },

    /* ------------------ تغییر شماره موبایل ------------------ */
    async submitMobile() {
      const ok = await this.confirmAction(
        "آیا از تغییر شماره همراه اطمینان دارید؟",
      );
      if (!ok) return;
      const posted = {
        nationalCode: this.selectedRow.nationalCode,
        mobileNumber: this.newMobile,
      };

      this.loading = true;

      this.$api
        .post("Cards/ChangeMobileNumber", posted)
        .then(({ data }) => {
          this.$swal({
            icon: data.status ? "success" : "error",
            text: data.status
              ? "شماره با موفقیت تغییر کرد"
              : data.errors[0].message,
          });
          if (data.status) {
            this.selectedRow = {};
            this.fetchCard();
            this.newMobile = "";
            this.closeModal("mobile");
          }
        })
        .finally(() => (this.loading = false));
    },

    /* ------------------ مسدود / رفع مسدودی ------------------ */
    async submitBlock() {
      const msg =
        this.blockType == 3
          ? "آیا از مسدود کردن کارت اطمینان دارید؟"
          : "آیا از فعال‌سازی کارت اطمینان دارید؟";

      const ok = await this.confirmAction(msg);
      if (!ok) return;

      const posted = {
        cardNumber: this.selectedRow.pan.replace(/-/g, ""),
        status: this.blockType,
      };

      this.loading = true;

      this.$api
        .post("Cards/CardStatusToggle", posted)
        .then(({ data }) => {
          this.$swal({
            icon: data.status ? "success" : "error",
            text: data.status
              ? this.blockType == 3
                ? "کارت مسدود شد"
                : "کارت فعال شد"
              : "خطا در انجام عملیات",
          });

          if (data.status) {
            this.selectedRow = {};
            this.fetchCard();
            this.blockType = "";
            this.closeModal("block");
          }
        })
        .finally(() => (this.loading = false));
    },

    /* ---------------------ریست تمام اطلاعات--------------------------*/
    resetInfo() {
      this.newPass = "";
      this.newPassRepeat = "";
      this.newMobile = "";
      this.blockType = "";
      this.blockDescription = "";
      this.pan = "";
      this.pinType = "";
      this.selectedRow = {};
      this.rows = [];
    },
  },
};
</script>

<style>
.is-invalid {
  border-color: red !important;
}
.active {
  color: green;
  font-weight: bold;
}
.diactive {
  color: red;
  font-weight: bold;
}
</style>
